/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Email/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Email({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/Topbar/InApp/Email"
  
}) {
let constantData = 'Notifications go to:'
let threadInboundNotificationValueData = fromData.useDataValue({ viewPath,
context: 'thread',
path: 'inbound_notification',
})
let aggregateData = fromAggregate.join(constantData, threadInboundNotificationValueData)
let constantData1 = 'Hub access granted to:'
let threadSendToEmailValueData = fromData.useDataValue({ viewPath,
context: 'thread',
path: 'send_to_email',
})
let aggregateData1 = fromAggregate.join(constantData1, threadSendToEmailValueData)
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="tiny"
 data="'Notifications go to:'"
 data="thread.inbound_notification"
 aggregate="/Simple/Data/aggregate.js join"
 text={aggregateData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="tiny"
 data="'Hub access granted to:'"
 data="thread.send_to_email"
 aggregate="/Simple/Data/aggregate.js join"
 text={aggregateData1}
/>
{children}
</React.Fragment>)
}